var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.loadingDone)?_c('Loader',{on:{"done":function($event){_vm.loadingDone = true}}}):_c('div',{staticClass:"dashboard"},[_c('ItemTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }